export const truncateText = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength)}...`;
};

export const trailString = (value: string, maxChar: number, cutOffPoint: number): string => {
  return value.length < maxChar ? value : `${value.substring(0, cutOffPoint)}...`;
};
